import { render, staticRenderFns } from "./CopiedTestQuestionItem.vue?vue&type=template&id=2b287646&scoped=true&"
import script from "./CopiedTestQuestionItem.vue?vue&type=script&lang=ts&"
export * from "./CopiedTestQuestionItem.vue?vue&type=script&lang=ts&"
import style0 from "./CopiedTestQuestionItem.vue?vue&type=style&index=0&id=2b287646&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b287646",
  null
  
)

export default component.exports